import { mmFetchWithResponse } from './mmFetchWithResponse';

/**
 * API client for Fulfillment Lifecycle dashboard endpoints.
 *
 * @see trunk/docs/ShipmentStatusUpgrade/FulfillmentLifecycleAPIContract.md
 */
const fulfillmentLifecycleApi = {
    /**
     * Get dashboard status for a facility and operating date.
     * Returns route-level status data with risk levels and aging metrics.
     *
     * @param {Object} params
     * @param {number} params.facilityId - Facility ID to query
     * @param {string} params.operatingDate - Operating date in YYYY-MM-DD format
     * @param {string[]} [params.orderSources] - Filter by order source (e.g., 'misfits', 'imperfect')
     * @param {string[]} [params.deliveryTypes] - Filter by delivery type ('DBI', 'CARRIER')
     * @param {AbortSignal} [params.signal] - AbortSignal for request cancellation
     * @returns {Promise<{status: boolean, msg: string, data: Object}>}
     */
    getStatus: async ({ deliveryTypes = [], facilityId, operatingDate, orderSources = [], signal }) => {
        let url = `api/logistics/fulfillment-lifecycle/v1/status?facilityId=${facilityId}&operatingDate=${operatingDate}`;

        orderSources.forEach((source) => {
            url += `&orderSources[]=${encodeURIComponent(source)}`;
        });

        deliveryTypes.forEach((type) => {
            url += `&deliveryTypes[]=${encodeURIComponent(type)}`;
        });

        return mmFetchWithResponse(url, { signal });
    },

    /**
     * Get route detail breakdown with shipment statuses and pallet assignments.
     *
     * @param {Object} params
     * @param {number} params.facilityId - Facility ID to query
     * @param {number} params.lineHaulId - Route line haul ID
     * @param {string} params.packDate - Pack date in YYYY-MM-DD format
     * @param {AbortSignal} [params.signal] - AbortSignal for request cancellation
     * @returns {Promise<{status: boolean, msg: string, data: Object}>}
     */
    getBreakdown: async ({ facilityId, lineHaulId, packDate, signal }) => {
        const url = `api/logistics/fulfillment-lifecycle/v1/status/${lineHaulId}/breakdown?facilityId=${facilityId}&packDate=${packDate}`;
        return mmFetchWithResponse(url, { signal });
    },
};

export { fulfillmentLifecycleApi };
